import { render, staticRenderFns } from "./MainActionButton.vue?vue&type=template&id=310e6738&scoped=true&"
import script from "./MainActionButton.vue?vue&type=script&lang=js&"
export * from "./MainActionButton.vue?vue&type=script&lang=js&"
import style0 from "./MainActionButton.vue?vue&type=style&index=0&id=310e6738&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "310e6738",
  null
  
)

export default component.exports